/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierNoteService = {
  async getBySupplierCode(code) {
    const requestScreenData = {
      url: "api/SupplierNote",
      top: "1",
      filter: `SupplierCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/SupplierNote",
      expand: "Supplier($select=Code,Name,SupplierTypeCode)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, supplierNote) {
    var payload = supplierNote;
    var url = "api/Save_SupplierNote";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.put(url, supplierNote.RecordId, payload, "Guid");
    }
  },
  async delete(supplierNote) {
    var payload = supplierNote;
    var url = "api/Save_SupplierNote";

    return await ApiService.delete(url, supplierNote.RecordId, "Guid");
  },
};

export { SupplierNoteService };
